import React from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MobileSearchInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
    value: string;
    onValueChange: (value: string) => void;
    placeholder?: string;
}

export const MobileSearchInput = React.forwardRef<HTMLInputElement, MobileSearchInputProps>(
    ({ value, onValueChange, placeholder = 'Search...', className, ...props }, ref) => {
        return (
            <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
                <input
                    ref={ref}
                    type="search"
                    inputMode="search"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    value={value}
                    onChange={(e) => onValueChange(e.target.value)}
                    placeholder={placeholder}
                    className={cn('mobile-input pl-10 pr-10', className)}
                    {...props}
                />
                {value && (
                    <button
                        type="button"
                        aria-label="Clear search"
                        onClick={() => onValueChange('')}
                        className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center w-8 h-8 rounded-full text-muted-foreground active:bg-accent"
                    >
                        <X className="h-4 w-4" />
                    </button>
                )}
            </div>
        );
    }
);

MobileSearchInput.displayName = 'MobileSearchInput';
